import { getHourExtensionAmount, type HourExtensionTier } from '@/components/event-simulator/utils/pricingAdjustmentUtils';

/** Colunas de `events` das horas adicionais; todas nulas quando o pedido não tem horas extras. */
export const NO_EXTRA_HOURS_COLUMNS = { event_hour_time_add: null, event_hour_add_price: null, event_hour_total: null } as const;

/**
 * Horas adicionais do item do carrinho em colunas de `events`. Sem horas extras devolve as colunas NULAS (não `{}`): ao tirar as
 * horas no carrinho, o pedido gravado não pode continuar com o valor antigo (caso THE-8F2C/THE-B01D: total sem as horas, mas
 * `event_hour_add_price` ainda R$ 810/R$ 550, e a conferência diária acusava o pedido).
 */
export const buildEventHourColumns = (item: { extraHours?: unknown; hourExtensionAmount?: unknown; eventHourTime?: unknown } | null | undefined) => {
  const extra = Number(item?.extraHours) || 0;
  if (!item || extra <= 0) return { ...NO_EXTRA_HOURS_COLUMNS };
  const raw = item.eventHourTime as string | undefined;
  const base = (() => {
    if (!raw) return 0;
    const [hh, mm] = String(raw).split(':').map(Number);
    if (Number.isFinite(hh)) return (hh || 0) + (Number.isFinite(mm) ? (mm || 0) / 60 : 0);
    const numeric = Number(raw);
    return Number.isFinite(numeric) ? numeric : 0;
  })();
  return {
    event_hour_time_add: String(extra),
    event_hour_add_price: Number(item.hourExtensionAmount) || 0,
    event_hour_total: String(base + extra),
  };
};

/**
 * Total do item com as horas adicionais refeitas sobre o subtotal NOVO. O valor das horas é percentual (ou fixo) da tabela do
 * cardápio; ao mudar convidados ou data, manter o valor antigo cobra as horas de outro tamanho de pedido (caso THE-B01D: 100 -> 250
 * convidados ficou com R$ 550 de horas, o certo era 5% de R$ 27.500 = R$ 1.375).
 */
export const repriceItemWithHours = (
  item: { extraHours?: unknown; hourExtensionAmount?: unknown; hourExtensionTiers?: unknown },
  subtotalBeforeHours: number,
): { total: number; hourAmount: number } => {
  const extra = Number(item.extraHours) || 0;
  const tiers = Array.isArray(item.hourExtensionTiers) ? (item.hourExtensionTiers as HourExtensionTier[]) : [];
  const hourAmount = extra > 0
    ? (tiers.length > 0 ? getHourExtensionAmount(subtotalBeforeHours, tiers, extra) : Number(item.hourExtensionAmount) || 0)
    : 0;
  return { total: subtotalBeforeHours + hourAmount, hourAmount };
};
